<!-- Contenu principal -->
<section class="verge-style container text-white pt-4">
  <div class="row gx-5 align-items-stretch">
    
    <!-- LEFT : Visual + overlay text -->
    <div class="col-lg-7 d-flex" *ngIf="spotlightArticle">
      <a [routerLink]="['/news', spotlightArticle.attributes?.slug]" 
         class="headline-link w-100 text-decoration-none text-white">
        <div class="headline-visual d-flex flex-column justify-content-end w-100">
          <div class="image-wrapper position-relative overflow-hidden">
            <div class="spotlight-badge">À LA UNE</div>
            <!-- Image principale avec gestion du chargement -->
            <img [src]="getImage(spotlightArticle)"
                 class="img-fluid w-100"
                 alt="Main Visual"
                 width="600"
                 height="400"
                 loading="lazy"
                 [style.aspect-ratio]="'3/2'"
                 (load)="onImageLoad($event)"
                 (error)="onImageError($event)">
            <div class="headline-overlay position-absolute bottom-0 start-0 text-white p-4">
              <h1 class="display-5 fw-bold mb-2">{{ spotlightArticle.attributes?.title }}</h1>
              <p class="small fw-bold mb-0">
                {{ getPublisher(spotlightArticle) }}&nbsp;| 
                {{ spotlightArticle.attributes?.publishedAt | date }}
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
    
    <!-- RIGHT : Top Stories -->
    <div class="col-lg-5 pt-lg-5 mt-lg-3 d-flex flex-column gap-3" *ngIf="data?.length > 0">
      <div class="top-stories-container" [style.min-height.px]="300">
        <h5 class="fw-bold mb-3">Dernières actualités</h5>
        <div class="top-stories d-flex flex-column gap-4" *ngIf="data && data.length > 0">
          <div class="story-block d-flex gap-3 border-bottom pb-3" *ngFor="let article of data">
            <!-- Thumbnails avec gestion du chargement -->
            <img [src]="getImage(article)"
                 class="thumb rounded"
                 alt="story thumbnail"
                 width="60"
                 height="60"
                 loading="lazy"
                 [style.aspect-ratio]="'1'"
                 (error)="onImageError($event)">
            <div class="flex-grow-1">
              <div class="d-flex align-items-center gap-2 mb-1">
                <span class="badge" [ngStyle]="{
                  'background-color': getCategory(article)?.bgColor,
                  'color': getCategory(article)?.textColor}">
                  {{ article.attributes?.field }}
                </span>
              </div>
              <a [routerLink]="['/news', article.attributes.slug]" 
                 class="story-title fw-bold mb-1">{{ article.attributes.title }}</a>
              <div class="story-meta small text-muted d-flex gap-2 flex-wrap align-items-center">
                <span>{{ getPublisher(article) }}</span>
                <span class="small">• {{ article.attributes?.publishedAt | date }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="browse-all-btn black-color">
          <a routerLink="/news" class="browse-all-btn-link fw-bold text-decoration-none">
            Découvrir toutes les actualités <i class="ri-arrow-right-s-line"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>